import { ajaxFunc } from '../tools';
const afterSale = {
  /****售后相关****/
  //获取售后商品信息
  afterSale: ajaxFunc('/order/get_order_details', 'get'),

  //申请退款
  refund_apply: ajaxFunc('/refund/refund_apply', 'post'),

  //申请退款列表
  refund_list: ajaxFunc('/refund/refund_list', 'get'),

  //查询提款订单详情
  refund_info: ajaxFunc('/refund/refund_info', 'get'),

  //退款进度详情表（订单详情）
  get_order_refund_log_list: ajaxFunc('/refund/get_order_refund_log_list', 'get'),

  //获取退款商品详情
  refund_apply_preposition: ajaxFunc('/refund/refund_apply_preposition', 'post'),

  //撤销申请售后订单
  refund_deal:ajaxFunc('/refund/refund_deal', 'post'),

  //获取物流公司
  allLogisticCompany:ajaxFunc('/loginstic/allLogisticCompany', 'post')


};

export default afterSale;



// WEBPACK FOOTER //
// ./src/request/api/afterSale.js